import { createAPI } from '@common'

export default {
  // 模板信息查询
  getTemplate: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.xfc0ufnqmbuf0jogp', 'get', config),
  // 新增、修改模板
  postTemplate: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.xfc0ufnqmbuf0dsfbuf', 'post', config),
  postTemplateDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.xfc0ufnqmbuf0efmfuf', 'post', config),
  //发布规则下删除接口
  postRuleDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tjuf0svmft0efmfuf', 'post', config),
  // 查询模板分组列表
  /* getGroups: (config) => createAPI('customEncryptApiName-1/0nfejby.tztufn0hspvqt', 'get', config),
  // 新建模板分组
  postGroups: (config) => createAPI('customEncryptApiName-1/0nfejby.tztufn0hspvqt', 'post', config),
  // 修改模板分组
  putGroups: (config) => createAPI('customEncryptApiName-1/0nfejby.tztufn0hspvqt', 'put', config),
  // 删除模板分组
  deleteGroups: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0hspvqt', 'delete', config), */
  // 查询模板分组列表
  getGroups: (config) => createAPI('customEncryptApiName-1/0nfejby.benjo0hspvqt', 'get', config),
  // 新建模板分组
  postGroups: (config) => createAPI('customEncryptApiName-1/0nfejby.benjo0hspvqt', 'post', config),
  // 修改模板分组
  putGroups: (config) => createAPI('customEncryptApiName-1/0nfejby.benjo0hspvqt', 'put', config),
  // 删除模板分组
  deleteGroups: (config) => createAPI('customEncryptApiName-1/0nfejby.benjo0hspvqt', 'delete', config),
  // 查询模板分组下是否含有模板
  deleteValidate: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.xfc0ufnqmbuf0hspvq0efmfuf0wbmjebufe',
      'get',
      config
    ),
  // 移动模板
  getTemplateMove: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.xfc0ufnqmbuf0npwf0hspvq', 'get', config),
  // 模板名称查重
  getTemplateDuplicate: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.xfc0ufnqmbuf0evqmjdbuf', 'get', config),  // 模板名称查重
  postTemplateUpdate: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.xfc0ufnqmbuf0vqebuf', 'post', config),
  // 获取SM2公钥
  // 获取服务端公钥
  getPublicKey: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.xfc0ufnqmbuf0hfuTN3QvcLfz', 'get', config),
  // 模板下载 ,应后端要求这个下载模板的接口时间调整到30s, 避免浏览器下载超时, 产品要求改成30s
  postTemplateDownload: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.xfc0ufnqmbuf0gjmf0epxompbe', 'post', config,  {
      timeout: 30000
    }),
  // 新增、修改区块
  postBlock: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.xfc0cmpdl0dsfbuf', 'post', config),
  // 区块名称查重
  getBlockDuplicate: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.xfc0cmpdl0evqmjdbuf', 'get', config),
  // 查询区块详情
  getBlock: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.xfc0cmpdl0jogp', 'get', config),
  getBlockGroupIsUsed: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.xfc0cmpdl0hspvq0jt0vtfe', 'get', config)
}
